export default "__VITE_ASSET__DkibSCWv__"